export const routes = ( prefix ) => [
    {
        path: `/${prefix}/items-setup/item-grouping`,
        name: `${prefix}.items-setup.item-grouping.index`,
        component: () => import('./item-grouping/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.items-setup.item-grouping.index`,
                PageDescription: "Item grouping listing/ Create",
            },
        },
    },
    {
        path: `/${prefix}/items-setup/specific-cash-items`,
        name: `${prefix}.items-setup.specific-cash-items.index`,
        component: () => import('./cash-items/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.items-setup.specific-cash-items.index`,
                PageDescription: "Specific cash items listing/ Create",
            },
        },
    },
];
